import { DataService } from "fg-library";
import { getModelMetaData } from "../fg-client-module/pages/fg-dynamic-page-builder/utils/dataUtils";
import { analyticalMock, generateMockItem, generateMockList } from "./mockDataService";

export async function getQueryServiceV2(dataService:DataService, req){
 const body = req.body;
    const code = body.filter.data.SUB_TYPE_CODE;
   const fields = await getModelMetaData(dataService, code);
   const mockData = generateMockList(fields.properties, 14 ,code );
   //console.log(mockData);
   return mockData;

}
export async function getQueryServiceApi(dataService:DataService, req){
 const body = req.body;
    const code = body.filterClause.SUB_TYPE_CODE;
   const fields = await getModelMetaData(dataService, code);
   const mockData = generateMockItem(fields.properties, 1 ,code );
   //console.log(mockData);
   return mockData;

}

export async function getAnalyticalQueryService(dataService:DataService, req){
   const code = req.filter.SUB_TYPE_CODE;
   const mockData = analyticalMock(req );
   //console.log(mockData);
   return mockData;

}

